import { useAuth0 } from "@auth0/auth0-react";
import { useSelector } from "@tanstack/react-store";
import { AIRLINE_CODE_CLAIM, LAST_LOGIN, ROLE_CLAIM } from "../constants/auth";
import { localStorageConfigStore } from "../stores/localStorageConfigStore";
import { getEnvironment } from "../utils/environment";
import type { UserRole } from "../types/userRole";

export type AuthInfo = ReturnType<typeof useAuth0> & {
  userRole?: UserRole;
  airlineCode?: string;
  isAdmin: boolean;
  isAirlineUser: boolean;
  isFirstLogin: boolean;
};

export const useAuth = (): AuthInfo => {
  const auth0Info = useAuth0();
  const { internal } = getEnvironment();
  const psmConfigFirstLogin = useSelector(localStorageConfigStore, ({ psmConfigFirstLogin }) => psmConfigFirstLogin);

  const userRole = auth0Info.user?.[ROLE_CLAIM];

  const airlineCode = auth0Info.user?.[AIRLINE_CODE_CLAIM];

  const lastLogin = auth0Info.user?.[LAST_LOGIN];

  const isAdmin = userRole === "etg_admin" || userRole === "internal_admin";

  const isAirlineUser = userRole === "airline_user";

  const isFirstLogin = !lastLogin || !!(internal && psmConfigFirstLogin);

  return {
    ...auth0Info,
    userRole,
    airlineCode,
    isAdmin,
    isAirlineUser,
    isFirstLogin,
  };
};
